import { render, staticRenderFns } from "./my_transaction.vue?vue&type=template&id=6f80ee6d&scoped=true"
import script from "./my_transaction.vue?vue&type=script&lang=js"
export * from "./my_transaction.vue?vue&type=script&lang=js"
import style0 from "./my_transaction.vue?vue&type=style&index=0&id=6f80ee6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f80ee6d",
  null
  
)

export default component.exports